import { formatNumber } from "@/utils/formats";

// GPU 사용량 수치의 표시 헬퍼. 요약 띠와 쿼터 표가 같은 함수를 쓴다. 그래서 같은 값은 두 자리에서
// 같은 문구다.

const emptyValue = "—";

// GPU-hours 는 소수 1자리까지만 표시한다. 팀 사이 조율에 쓰는 값이므로 분 단위 정밀도는 필요 없다.
export function formatGpuHours(hours: number): string {
  if (!Number.isFinite(hours)) {
    return emptyValue;
  }
  return formatNumber(Math.round(hours * 10) / 10);
}

// 비용은 USD 정수로 표시한다. 단가가 근삿값이므로 센트 단위는 뜻이 없다. 서버에 단가가 없으면
// null 이 온다. 그때는 0 이 아니라 값 없음으로 표시한다.
export function formatUsd(cost: number | null): string {
  if (cost === null || !Number.isFinite(cost)) {
    return emptyValue;
  }
  return `$${formatNumber(Math.round(cost))}`;
}
